/**
 * SelectProjectPrompt
 *
 * Empty-state message rendered on project-gated pages (Outcomes, Delivery,
 * G-Brain, future project-scoped views) when no project is selected. The
 * page typically also surfaces a project selector above this prompt; this
 * component just provides the consistent "choose a project to continue"
 * signal.
 *
 * Rendering this instead of firing data queries prevents the page from
 * showing "Loading..." states that will never resolve without a project.
 */
export interface SelectProjectPromptProps {
  /** Short trailing phrase describing what's behind the gate. */
  action: string;
  /** Optional: override default "Choose a project above to" prefix. */
  prefix?: string;
}

export function SelectProjectPrompt({
  action,
  prefix = 'Choose a project above to',
}: SelectProjectPromptProps): React.ReactElement {
  return <div className="text-sm text-muted-foreground">{`${prefix} ${action}.`}</div>;
}
